export const screenTexts = {
  filters: {
    all: "Todos",
    promotions: "Promociones",
    payments: "Pagos"
  },
  markAll: "Marcar todo como leído",
  markAllFailed:
    "No se pudieron marcar las notificaciones. Inténtalo de nuevo.",
  close: "Cerrar",
  groups: {
    today: "Hoy",
    earlier: "Antes"
  },
  emptyTitle: "Aún no hay notificaciones",
  labels: {
    promotions: "Promociones",
    payments: "Pagos",
    system: "Sistema",
    kyc: "KYC Aprobado",
    fallback: "Notificación"
  },
  age: {
    now: "ahora",
    minutes: (count: number) => `${count} min`,
    hours: (count: number) => `${count} h`,
    days: (count: number) => `${count} d`
  }
} as const
